import React from "react";
import FormattedDate from "./FormattedDate";


export default function DataBox(props) {
	return (
    <div className="col-4 m-auto border-end" id="data-box">
      <FormattedDate date={props.data.date} />
      <h2 className="select m-1" id="city">
        {props.data.city}
      </h2>{" "}
      <div className="cap" id="description">
        {props.data.description}
      </div>{" "}
    </div>
  );
}
